// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-management .license-table .status-cell .status-active {
  color: #16cb1d;
  font-weight: 500;
}
.license-management .license-table .status-cell .status-pending {
  color: #ff9800;
  font-weight: 500;
}
.license-management .license-table .status-cell .status-expired {
  color: #f44336;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/License/License.scss"],"names":[],"mappings":"AAGG;EACC,cAAA;EACA,gBAAA;AAFJ;AAKG;EACC,cAAA;EACA,gBAAA;AAHJ;AAMG;EACC,cAAA;EACA,gBAAA;AAJJ","sourcesContent":[".license-management {\n\t.license-table {\n\t\t.status-cell {\n\t\t\t.status-active {\n\t\t\t\tcolor: #16cb1d;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t\n\t\t\t.status-pending {\n\t\t\t\tcolor: #ff9800;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t\n\t\t\t.status-expired {\n\t\t\t\tcolor: #f44336;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t}\n\t}\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
